import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../utils';
import { H2, H3, Typography } from './Typography';

function GuidelinesText({ withTitle }) {
  return (
    <>
      {withTitle && (
        <H2 fontWeight={700} margin={{ bottom: 'large' }}>
          Guidelines
        </H2>
      )}

      <H3 margin={{ bottom: 'xs' }} color={colors.t07} textAlign="left">
        Record a phone conversation:
      </H3>

      <div>
        <Typography textAlign="left" margin={{ bottom: 'm' }}>
          In these tasks, you’ll record a conversation over the phone with a partner based on the
          provided script/scenario.
        </Typography>
        <Typography textAlign="left" margin={{ bottom: 'm' }}>
          We keep all personal information confidential by connecting you to anonymous conference
          lines while you complete these tasks. As a designated “Agent”, you’ll be given complete
          control over initiating the conference line, as well as the recording of the scenario you
          are given.
        </Typography>
        <Typography textAlign="left" margin={{ bottom: 'm' }}>
          <strong>Note: </strong>
          <span>
            Although you’ll record into your phone, you’ll control the conference line through your
            computer. That means hanging up your phone won’t necessarily register as “hanging up” in
            the conference line interface. It’s best to think of your phone as a microphone, and
            your computer as “mission control” for these calls. Although you’ll record into your
            phone, you’ll control the conference line through your computer.
          </span>
        </Typography>
        <Typography textAlign="left" margin={{ bottom: 'm' }}>
          The required basic steps are quite simple:
        </Typography>
        <Typography textAlign="left">
          <span>1. Read the scenario/script and accompanying instructions carefully.</span>
          <br />
          <span>You</span>
          <strong> must view the scenario before you can start calls. </strong>
        </Typography>
        <Typography textAlign="left" margin={{ bottom: 'm' }}>
          2. Once you have a grasp on the scenario/script and requirements, select “Start call” Our
          anonymous conference line will dial both you and your partner’s cellphone. Answer the call
          to connect with your partner on the other line.
        </Typography>
        <Typography textAlign="left" margin={{ bottom: 'm' }}>
          3. Double check that your partner understands the script and is ready to record. Once you
          get the affirmative, select the “Start Recording” button on the desktop interface.
        </Typography>
        <Typography textAlign="left" margin={{ bottom: 'm' }}>
          4. Select “Stop recording” on the desktop once you’ve completed a solid take of the
          scenario. You can then say goodbye to your partner, “hang up” the conference line from the
          desktop interface, and move on to evaluating the call.
        </Typography>
        <Typography textAlign="left" margin={{ bottom: 'm' }}>
          5. Answer the evaluation questions and you’ll be able to submit.
        </Typography>
        <H3 margin={{ bottom: 'm' }} color={colors.t07} textAlign="left">
          FAQ
        </H3>
        <Typography textAlign="left" margin={{ bottom: 'm' }} fontWeight={700}>
          What if one of us makes a mistake in the scenario?
        </Typography>
        <Typography textAlign="left" margin={{ bottom: 'm' }}>
          1. You can always “Stop Recording” and then select “Restart recording” to start again.
          Note, you will have to restart from the beginning if you choose to rerecord.
        </Typography>
        <Typography textAlign="left" margin={{ bottom: 'm' }} fontWeight={700}>
          What if I get disconnected from my partner?
        </Typography>
        <Typography textAlign="left" margin={{ bottom: 'm' }}>
          2. If you get disconnected from your partner and you want to give it another go, you’ll
          have to re-initiate the conference call. Just “hang up” and then choose to “Re-dial.”
        </Typography>
        <Typography textAlign="left" margin={{ bottom: 'm' }} fontWeight={700}>
          What if my partner is making it difficult to complete the call?
        </Typography>
        <Typography textAlign="left" margin={{ bottom: 'm' }}>
          3. If you’re having a particularly hard time with an assigned partner, go ahead and stop
          your recording, politely hang up, and move on to evaluation. You’ll have the opportunity
          to tell us that your partner made task completion difficult on the feedback form.
        </Typography>
        <Typography textAlign="left" margin={{ bottom: 'm' }} fontWeight={700}>
          What if audio/technical issues are making it difficult to complete the call?
        </Typography>
        <Typography textAlign="left" margin={{ bottom: 'm' }}>
          4. If technical difficulties are making it difficult to complete a call, you can try
          hanging up and redialing once or twice. If it’s still an issue, go ahead and stop your
          recording, politely hang up, and go to evaluation. You’ll have the opportunityto tell us
          that you were experiencing technical issues on your feedback form.
        </Typography>
        <Typography textAlign="left" margin={{ bottom: 'm' }} fontWeight={700}>
          What if I leave the page or close the browser?
        </Typography>
        <Typography textAlign="left" margin={{ bottom: 'm' }}>
          5. If you choose to leave the call before submitting, your work might be lost.
        </Typography>
      </div>
    </>
  );
}

GuidelinesText.propTypes = {
  withTitle: PropTypes.bool
};

GuidelinesText.defaultProps = {
  withTitle: false
};

export { GuidelinesText };
